const CREATOR_SUBSCRIBE_RESUME_KEY = 'thspian.creatorSubscribe.resume';

/** Flutterwave Billing add-card tx_ref prefix (`BILLCARD-…`). */
export function isFlutterwaveBillingCardTxRef(txRef?: string | null): boolean {
    if (!txRef) return false;
    return /^BILLCARD[-_]/i.test(String(txRef).trim());
}

export function stashCreatorSubscribeResume(planCode: string): void {
    if (!planCode || typeof sessionStorage === 'undefined') return;
    try {
        sessionStorage.setItem(
            CREATOR_SUBSCRIBE_RESUME_KEY,
            JSON.stringify({
                planCode: String(planCode),
                preferNewestCard: true,
                at: Date.now(),
            }),
        );
    } catch {
        /* ignore quota / private mode */
    }
}

/** Read + clear pending plan so the subscribe modal can reopen after add-card. */
export function consumeCreatorSubscribeResume(): {
    planCode: string;
    preferNewestCard?: boolean;
} | null {
    if (typeof sessionStorage === 'undefined') return null;
    try {
        const raw = sessionStorage.getItem(CREATOR_SUBSCRIBE_RESUME_KEY);
        sessionStorage.removeItem(CREATOR_SUBSCRIBE_RESUME_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as {
            planCode?: string;
            preferNewestCard?: boolean;
            at?: number;
        };
        const planCode = parsed?.planCode ? String(parsed.planCode) : '';
        if (!planCode) return null;
        // Ignore stale resumes older than 2 hours
        if (parsed.at && Date.now() - Number(parsed.at) > 2 * 60 * 60 * 1000) {
            return null;
        }
        return {
            planCode,
            preferNewestCard: Boolean(parsed.preferNewestCard),
        };
    } catch {
        return null;
    }
}

export { CREATOR_SUBSCRIBE_RESUME_KEY };
